"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./style.css");
var _login = require("../../../consts/login");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @Author: liujunhong
 * @Date: 2022/9/24
 * @Desc: 合并登录方式
 */

var WE_GAME_LOGIN_URL = "https://login.wegame.com.cn/web/oauth2.0/login/authorize?response_type=code&client_id=7019928274&rail_game_id=2001617&redirect_uri=http%3A%2F%2Faccountv5.gyyx.cn%2Fv1%2Faccount%2Fwegamelogin&scope=openid&state=".concat(encodeURIComponent(window.location.href));
var MergeLogin = function MergeLogin(props) {
  var onClose = props.onClose,
    onTypeClick = props.onTypeClick,
    _props$closableMerge = props.closableMerge,
    closableMerge = _props$closableMerge === void 0 ? true : _props$closableMerge;
  var handleClick = function handleClick(type) {
    onTypeClick && onTypeClick(type);
  };
  var handleClose = function handleClose() {
    onClose && onClose();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_content"
  }, closableMerge && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_close",
    onClick: handleClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_item",
    onClick: function onClick() {
      return handleClick(_login.MERGE_LOGIN_TYPE.GY);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "//g.gyyxcdn.cn/action/wegame/common/images/gy_login.png",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_merge_login_btn",
    id: "btn_merge_login_gy"
  }, "\u7528\u6237\u767B\u5F55")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_merge_login_item",
    onClick: function onClick() {
      return handleClick(_login.MERGE_LOGIN_TYPE.TENCENT);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "//g.gyyxcdn.cn/action/wegame/common/images/wegame_login.png",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: WE_GAME_LOGIN_URL,
    id: "btn_merge_login_tc",
    className: "gy_merge_login_btn gy_merge_login_tc_btn"
  }, "\u7528\u6237\u767B\u5F55")))));
};
var _default = MergeLogin;
exports.default = _default;